import * as React from "react";
interface iconprop {}
const TravAssistCall = (props: iconprop) => (
  <svg
    width={70}
    height={69}
    viewBox="0 0 70 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_841_15232)">
      <mask
        id="mask0_841_15232"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={70}
        height={69}
      >
        <path
          d="M58.1782 0H12.5765C6.15167 0 0.943359 5.20847 0.943359 11.6334V57.2366C0.943359 63.6615 6.15167 68.87 12.5765 68.87H58.1782C64.603 68.87 69.8113 63.6615 69.8113 57.2366V11.6334C69.8113 5.20847 64.603 0 58.1782 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_841_15232)">
        <path
          d="M58.1782 0H12.5765C6.15167 0 0.943359 5.20847 0.943359 11.6334V57.2366C0.943359 63.6615 6.15167 68.87 12.5765 68.87H58.1782C64.603 68.87 69.8113 63.6615 69.8113 57.2366V11.6334C69.8113 5.20847 64.603 0 58.1782 0Z"
          fill="url(#paint0_linear_841_15232)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.835 0H58.6358C65.0606 0 70.2689 5.20847 70.2689 11.6334V57.2366C70.2689 63.6615 65.0606 68.87 58.6358 68.87H35.835V0Z"
          fill="url(#paint1_radial_841_15232)"
        />
      </g>
      <path
        d="M51.2725 36.3282V33.1099C51.2725 28.8949 49.5982 24.8521 46.6176 21.8718C43.6373 18.8912 39.5948 17.2168 35.3799 17.2168C31.1651 17.2168 27.1224 18.8912 24.1422 21.8718C21.1616 24.8522 19.4873 28.8949 19.4873 33.1099V36.3282C18.6639 36.8531 18.1646 37.7617 18.1631 38.7385V41.6081C18.1631 42.369 18.4654 43.0989 19.0034 43.6373C19.5418 44.1753 20.2717 44.4776 21.0326 44.4776C21.0326 45.2386 21.3349 45.9685 21.8729 46.5068C22.4113 47.0449 23.1412 47.3472 23.9021 47.3472H25.3368C25.9075 47.3472 26.4552 47.1205 26.8586 46.7169C27.2621 46.3134 27.4889 45.7657 27.4889 45.1951V35.1516C27.4889 34.5809 27.2621 34.0332 26.8586 33.6297C26.4551 33.2263 25.9074 32.9994 25.3368 32.9994H23.9021C23.1411 32.9994 22.4112 33.3018 21.8729 33.8398C21.3349 34.3782 21.0326 35.1081 21.0326 35.869C20.9945 35.869 20.9608 35.8789 20.9221 35.8805V33.1099C20.9224 30.3691 21.7073 27.6856 23.1847 25.3772L24.4084 26.6019C24.5567 26.7527 24.7649 26.829 24.9753 26.8098C25.1857 26.7925 25.3778 26.6829 25.5005 26.5106C27.7766 23.3144 31.4563 21.4149 35.3797 21.4108C38.598 21.3999 41.6862 22.6799 43.9529 24.9648C44.4327 25.4404 44.8699 25.9575 45.2586 26.5101C45.3806 26.683 45.5725 26.7932 45.7829 26.8114H45.8437H45.844C46.0343 26.8114 46.2168 26.7359 46.3513 26.601L47.575 25.3773C49.0524 27.6857 49.8373 30.3693 49.8377 33.11V35.8806C49.8005 35.8806 49.7659 35.8691 49.7272 35.8691C49.7272 35.1082 49.4249 34.3782 48.8868 33.8399C48.3485 33.3019 47.6186 32.9995 46.8577 32.9995H45.423C44.8523 32.9995 44.3046 33.2263 43.9011 33.6298C43.4977 34.0334 43.2709 34.581 43.2709 35.1517V45.1952C43.2722 45.7566 43.4925 46.2953 43.8851 46.6963C44.2778 47.0976 44.8116 47.3291 45.3728 47.3423C45.2152 47.9578 44.8578 48.5032 44.3565 48.8936C43.8553 49.284 43.2388 49.4973 42.6038 49.4996H40.4014C40.4014 48.9289 40.1747 48.3812 39.7712 47.9777C39.3676 47.5743 38.82 47.3474 38.2493 47.3474H36.8146C36.0457 47.3474 35.3353 47.7577 34.9507 48.4235C34.5664 49.0894 34.5664 49.9099 34.9507 50.5757C35.3354 51.2415 36.0457 51.6518 36.8146 51.6518H38.2493C38.8581 51.6499 39.4371 51.3889 39.842 50.9344H42.6039C43.6204 50.9334 44.6036 50.5725 45.3795 49.9163C46.1555 49.2597 46.674 48.3496 46.8434 47.3474H46.8578C47.6187 47.3474 48.3486 47.0451 48.8869 46.5071C49.4249 45.9687 49.7273 45.2388 49.7273 44.4779C50.4882 44.4779 51.2181 44.1755 51.7564 43.6375C52.2944 43.0991 52.5967 42.3692 52.5967 41.6083V38.7387C52.5951 37.7619 52.0959 36.8533 51.2725 36.3284V36.3282ZM21.0322 43.0429C20.6518 43.0429 20.2867 42.8917 20.0177 42.6227C19.7487 42.3537 19.5975 41.9885 19.5975 41.6081V38.7385C19.5975 38.358 19.7487 37.9929 20.0177 37.7239C20.2867 37.4549 20.6518 37.3037 21.0322 37.3037V43.0429ZM51.1618 41.6081C51.1618 41.9885 51.0107 42.3537 50.7417 42.6227C50.4727 42.8917 50.1076 43.0429 49.7271 43.0429V37.3037C50.1076 37.3037 50.4727 37.4549 50.7417 37.7239C51.0107 37.9929 51.1618 38.358 51.1618 38.7385V41.6081Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_841_15232"
        x1={35.3773}
        y1={-5.5406e-7}
        x2={16.7856}
        y2={70.5767}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#027863" />
        <stop offset={1} stopColor="#163E36" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_841_15232"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(62.8744 2.53307e-06) rotate(110.806) scale(77.0415 68.4417)"
      >
        <stop stopColor="#00E6BC" />
        <stop offset={1} stopColor="#01715D" stopOpacity={0} />
      </radialGradient>
      <clipPath id="clip0_841_15232">
        <rect
          x={0.943359}
          width={68.8679}
          height={68.87}
          rx={34.434}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
export { TravAssistCall };
